export default function SistersIntro() {
  return (
    <section id="sisters" className="w-full py-10 md:py-20 bg-primary-100 relative overflow-hidden scroll-mt-20">
      <div className="absolute inset-0 pointer-events-none select-none" aria-hidden="true">
        <div className="w-14 h-14 flex items-center justify-center absolute top-8 left-[5%] opacity-[0.06] rotate-[-15deg] animate-float">
          <i className="fa-solid fa-paw text-5xl text-foreground-950"></i>
        </div>
        <div className="w-16 h-16 flex items-center justify-center absolute top-24 right-[8%] opacity-[0.05] rotate-[20deg] animate-drift" style={{ animationDelay: '0.7s' }}>
          <i className="fa-solid fa-paw text-6xl text-foreground-950"></i>
        </div>
        <div className="w-12 h-12 flex items-center justify-center absolute bottom-20 left-[10%] opacity-[0.06] rotate-[25deg] animate-float" style={{ animationDelay: '1.4s' }}>
          <i className="fa-solid fa-paw text-4xl text-foreground-950"></i>
        </div>
        <div className="w-14 h-14 flex items-center justify-center absolute bottom-24 right-[12%] opacity-[0.05] rotate-[-30deg] animate-drift" style={{ animationDelay: '2.1s' }}>
          <i className="fa-solid fa-paw text-5xl text-foreground-950"></i>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 md:px-8 relative z-10">
        <h2 className="text-center text-3xl md:text-4xl font-black text-primary-500 mb-3">Meet the Real-Life Sisters</h2>
        <p className="text-center text-foreground-700 text-base md:text-lg mb-8 md:mb-12 max-w-2xl mx-auto">
          Gracie and Lily are real Bichon Frise sisters. Their personalities and close bond inspired
          the magical world of Gracie & Lily Adventures.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
          <div className="bg-white/80 rounded-2xl overflow-hidden flex flex-col">
            <div className="w-full bg-primary-200 flex items-center justify-center p-4">
              <img
                alt="Gracie - The Brave Explorer"
                className="w-full h-auto max-h-72 object-contain rounded-2xl ring-4 ring-white drop-shadow-[0_8px_20px_rgba(0,0,0,0.18)] cursor-pointer hover:scale-105 transition-transform duration-300"
                src="https://storage.readdy-site.link/project_files/68a07134-6060-4041-8161-9728c6c3b4d7/af329b9c-13fa-4a60-b5b7-75a34b96f380_Wave-red.png"
              />
            </div>
            <div className="p-6 md:p-8 flex flex-col gap-3">
              <p className="text-accent-400 font-bold text-sm">🌟 Gracie</p>
              <h3 className="text-xl md:text-2xl font-black text-primary-500">The Brave Explorer</h3>
              <p className="text-foreground-700 leading-relaxed text-sm">
                Gracie is the adventurous, curious, and brave explorer. She loves to lead the way and
                discover new places.
              </p>
              <p className="font-extrabold text-primary-500 text-sm mt-2">Adventurous • Curious • Brave</p>
            </div>
          </div>

          <div className="bg-white/80 rounded-2xl overflow-hidden flex flex-col">
            <div className="w-full bg-primary-50 flex items-center justify-center p-4">
              <img
                alt="Lily - The Kind Heart"
                className="w-full h-auto max-h-72 object-contain rounded-2xl ring-4 ring-white drop-shadow-[0_8px_20px_rgba(0,0,0,0.18)] cursor-pointer hover:scale-105 transition-transform duration-300"
                src="https://storage.readdy-site.link/project_files/68a07134-6060-4041-8161-9728c6c3b4d7/9b9fed9b-8990-4685-825d-68d3f51ad36b_blue-dog.png"
              />
            </div>
            <div className="p-6 md:p-8 flex flex-col gap-3">
              <p className="text-accent-500 font-bold text-sm">💖 Lily</p>
              <h3 className="text-xl md:text-2xl font-black text-primary-500">The Kind Heart</h3>
              <p className="text-foreground-700 leading-relaxed text-sm">
                Lily is the caring, gentle, and kind-hearted friend. She spreads kindness and helps
                others wherever she goes.
              </p>
              <p className="font-extrabold text-primary-500 text-sm mt-2">Caring • Gentle • Kind-hearted</p>
            </div>
          </div>
        </div>

        <p className="text-center text-foreground-700 text-sm md:text-base mt-8 md:mt-10 max-w-3xl mx-auto">
          Together, they take children on imaginative adventures built around friendship, discovery,
          kindness, courage, and helping others.
        </p>
      </div>
    </section>
  );
}